/**
 * Created by User on 17/02/2016.
 */
import Observer from '../utils/Observer';
import AdConsts from '../AdConsts';
import IMAElement from './elements/IMAElement';
import YandexElement from './elements/YandexElement';
import AdElementFactory from './AdElementFactory';
import AdURLModificator from '../utils/AdURLModificator';

export default BlockMember;

function BlockMember(timeStart, timeEnd, videoState, timeout, timeUnit, priority, type, urls, repeatInterval, minPauseDuration) {
  this.timeStart = timeStart || -1;
  this.timeEnd = timeEnd || -1;
  this.videoState = videoState || null;
  this.timeout = timeout || -1;
  this.globalTimeout = -1;
  this.timeUnit = timeUnit || null;
  this.priority = priority || -1;
  this.type = type || null;
  this.urls = urls || null;
  this.minPauseDuration = minPauseDuration || null;
  this.repeatInterval = repeatInterval || -1;
  this.blockEnd = -1;

  //'true' if this member in some reason hasn't showed
  this.failed = false;

  var self = this;
  var _urlIndex = 0;
  var _adElement = null;
  var _analyticsTag = null;
  Observer.on('ad:forceTrackingEvent', onForceTrackingEvent);


  this.dispose = function() {
    Observer.off([ AdConsts.ELEMENT_CREATING_SUCCESS, AdConsts.ELEMENT_CREATING_FAIL, AdConsts.GOOGLE_IN_VAST, AdConsts.ELEMENT_NEED_SKIP ], _onAdElementEvent);
    Observer.off('ad:forceTrackingEvent', onForceTrackingEvent);
    _adElement = null;
  };

  this.show = function(position, cacheBoost, sizeInfo) {
    _createAndLoadElement(self.urls[_urlIndex].url, self.urls[_urlIndex].analytics_tag, position, cacheBoost, sizeInfo);
  };

  this.completed = function() {
    Observer.emit(self.failed ? AdConsts.MEMBER_ERROR : AdConsts.MEMBER_COMPLETE, self);
  };

  this.track = function(eventName, params) {
    if (_adElement && typeof _adElement.track === 'function') {
      _adElement.track.call(_adElement, eventName, params);
    }
  };

  this.getExtensionValue = function(key) {
    var result = null;
    if (_adElement && _adElement.vastData && key in _adElement.vastData) {
      result = _adElement.vastData[key];
    }
    return result;
  };

  var _needSkip = function(url, analyticsTag, sizeInfo) {

    if (analyticsTag && analyticsTag.indexOf('zskip') !== -1) {
      if (!sizeInfo) return true;
      if (sizeInfo.intersectionRatio === 0) return true;
    }
    return false;
  };

  var _createAndLoadElement = function(url, analyticsTag, position, cacheBoost, sizeInfo) {
    _analyticsTag = "";
    Observer.on([ AdConsts.ELEMENT_CREATING_SUCCESS, AdConsts.ELEMENT_CREATING_FAIL, AdConsts.GOOGLE_IN_VAST, AdConsts.ELEMENT_NEED_SKIP ], _onAdElementEvent);

    url = AdURLModificator.getInstance().modifyURL(url, position, cacheBoost);
    if (_needSkip(url, analyticsTag, sizeInfo)) {
      Observer.emit(AdConsts.ELEMENT_NEED_SKIP, { url: url });
      return;
    }
    if (analyticsTag) _analyticsTag = analyticsTag;
    _adElement = AdElementFactory.createElement(url);
    if (_adElement) {
      _adElement.load();
      Observer.emit(AdConsts.MEMBER_BEGIN_LOADING, self);
    } else {
      _onAdElementEvent({ name: AdConsts.ELEMENT_CREATING_FAIL, data:{ message: 'AdFactory cannot create element', url: url } });
    }
  };

  var _onAdElementEvent = function(event) {
    switch (event.name) {
      case AdConsts.ELEMENT_CREATING_SUCCESS:
        Observer.off([ AdConsts.ELEMENT_CREATING_SUCCESS, AdConsts.ELEMENT_CREATING_FAIL, AdConsts.GOOGLE_IN_VAST, AdConsts.ELEMENT_NEED_SKIP ], _onAdElementEvent);
        Observer.emit(AdConsts.MEMBER_READY_TO_SHOW, self);
        break;
      case AdConsts.ELEMENT_NEED_SKIP:
      case AdConsts.ELEMENT_CREATING_FAIL:
        _analyticsTag = null;
        if (_urlIndex < self.urls.length - 1) {
          ++_urlIndex;
          _createAndLoadElement(self.urls[_urlIndex].url, self.urls[_urlIndex].analytics_tag);
        } else {
          _urlIndex = 0;
          self.failed = true;
          Observer.off([ AdConsts.ELEMENT_CREATING_SUCCESS, AdConsts.ELEMENT_CREATING_FAIL, AdConsts.GOOGLE_IN_VAST, AdConsts.ELEMENT_NEED_SKIP ], _onAdElementEvent);
          Observer.emit(AdConsts.MEMBER_ERROR, self);
        }
        break;
      case AdConsts.GOOGLE_IN_VAST:
        _adElement = new IMAElement(event.data.url, event.data.vastDocument);
        _adElement.load();
        break;
    }
  };

  function onForceTrackingEvent(event) {
    self.track(event.data);
  }

  Object.defineProperties(this, {
    'mediaFileExtension': {
      enumerable: true,
      configurable: true,
      get: function () {
        var result = null;
        if (_adElement && _adElement.vastData && _adElement.vastData.mediaFile && _adElement.vastData.mediaFile.length > 0) {
          if (_adElement instanceof IMAElement) {
            result = 'ima';
          } else if (_adElement instanceof YandexElement) {
            result = 'yandex';
          } else {
            var type = _adElement.vastData.mediaFile[0].type;

            if (type && type.indexOf('image') === 0) return 'jpg'; // image/jpeg

            var name = _adElement.vastData.mediaFile[0].url;
            var paramIndex = name.indexOf('?');
            if (paramIndex === -1) {
              paramIndex = name.lastIndexOf('#');
            }
            if (paramIndex !== -1) {
              name = name.substring(0, paramIndex);
            }
            result = name.slice(name.lastIndexOf('.') + 1);
          }
        }
        return result;
      }
    },
    'mediaFileUrl': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = null;
        if (_adElement && _adElement.vastData && _adElement.vastData.mediaFile && _adElement.vastData.mediaFile.length > 0) {
          result = _adElement.vastData.mediaFile[0].url;
        } else if (_adElement instanceof IMAElement) {
          result = _adElement.url;
        }
        return result;
      }
    },
    'mediaFileName': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = null;
        if (_adElement && _adElement.vastData && _adElement.vastData.mediaFile && _adElement.vastData.mediaFile.length > 0) {
          var name = _adElement.vastData.mediaFile[0].url;
          var index = name.lastIndexOf('?');
          if (index != -1) {
            name = name.substring(0, index);
          }
          index = name.lastIndexOf('/');
          if (index != -1) {
            name = name.slice(index + 1);
          }
          result = name;
        }
        return result;
      }
    },
    'mediaFileDimensions': {
      enumerable: true,
      configurable: true,
      get: function() {
        var dims = {};
        if (_adElement && _adElement.vastData && _adElement.vastData.mediaFile && _adElement.vastData.mediaFile.length > 0) {
          dims.width = _adElement.vastData.mediaFile[0].width;
          dims.height = _adElement.vastData.mediaFile[0].height;
        }
        return dims;
      }
    },
    'loadedXMLURL': {
      enumerable: true,
      configurable: true,
      get: function() {
        if (_adElement) {
          return self.urls[_urlIndex];
        }
        return null;
      }
    },
    'vastDataDuration': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = 0;
        if (_adElement && _adElement.vastData && _adElement.vastData.duration && _adElement.vastData.duration.length > 0) {
          result = _adElement.vastData.duration[0];
        } else if (_adElement && _adElement.vastData && _adElement.vastData.mediaFile && _adElement.vastData.mediaFile.length > 0) {
          if (_adElement.vastData.mediaFile[0].duration) {
            result = _adElement.vastData.mediaFile[0].duration;
          }
        }
        return result;
      }
    },
    'linear': {
      enumerable: true,
      configurable: true,
      get: function() {
        var result = null;
        if (_adElement) {
          result = _adElement.linear;
        }
        return result;
      }
    },
    'element': {
      enumerable: true,
      configurable: true,
      get: function() {
        return _adElement;
      }
    },
    'analyticsTag': {
      enumerable: true,
      configurable: true,
      get: function() {
        return _analyticsTag;
      }
    }
  });
}
BlockMember.prototype.constructor = BlockMember;
